/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Encore
 *
 * 2 = Genus
 *
 * 3 = Santander
 */
export enum LenderTypeEnum {
  Encore = 1,
  Genus = 2,
  Santander = 3,
}
